export const imageData = [
    {
      "date": "2025-12-17",
      "title":"Karácsonyi ünnepség",
          "mainimage":"../images/bastya/2025.12.17 - karacsonyiunnepseg/1.jpg",
      "images": 
        {
          "image1":"../images/bastya/2025.12.17 - karacsonyiunnepseg/1.jpg",
          "image2":"../images/bastya/2025.12.17 - karacsonyiunnepseg/2.jpg",
          "image3":"../images/bastya/2025.12.17 - karacsonyiunnepseg/3.jpg",
          "image4":"../images/bastya/2025.12.17 - karacsonyiunnepseg/4.jpg",
          "image5":"../images/bastya/2025.12.17 - karacsonyiunnepseg/5.jpg",
          "image6":"../images/bastya/2025.12.17 - karacsonyiunnepseg/6.jpg",
          "image7":"../images/bastya/2025.12.17 - karacsonyiunnepseg/7.jpg",
          "image8":"../images/bastya/2025.12.17 - karacsonyiunnepseg/8.jpg",
          "image9":"../images/bastya/2025.12.17 - karacsonyiunnepseg/9.jpg",
          "image10":"../images/bastya/2025.12.17 - karacsonyiunnepseg/10.jpg",
          "image11":"../images/bastya/2025.12.17 - karacsonyiunnepseg/11.jpg",
          "image12":"../images/bastya/2025.12.17 - karacsonyiunnepseg/12.jpg",
          "image13":"../images/bastya/2025.12.17 - karacsonyiunnepseg/13.jpg",
          "image14":"../images/bastya/2025.12.17 - karacsonyiunnepseg/14.jpg",
          "image15":"../images/bastya/2025.12.17 - karacsonyiunnepseg/15.jpg",
          "image16":"../images/bastya/2025.12.17 - karacsonyiunnepseg/16.jpg",
          "image17":"../images/bastya/2025.12.17 - karacsonyiunnepseg/17.jpg",
          "image18":"../images/bastya/2025.12.17 - karacsonyiunnepseg/18.jpg",
          "image19":"../images/bastya/2025.12.17 - karacsonyiunnepseg/19.jpg",
        }
      
    },
    {
      "date": "2025-12-31",
      "title":"Boldog Új Évet kívánunk",
      "mainimage":"../images/bastya/2026.01.01-Buek/1.jpg",
      "images": 
        {
          "image1": "../images/bastya/2026.01.01-Buek/1.jpg",
          "image2": "../images/bastya/2026.01.01-Buek/2.jpg",
          "image3": "../images/bastya/2026.01.01-Buek/3.jpg",
          "image4": "../images/bastya/2026.01.01-Buek/4.jpg",
        }
      
    },
    {
        "date": "2026-01-21",
        "title":"Pótszilveszter",
        "mainimage":"../images/bastya/2026.01.21 - pótszilveszter/1.jpg",
        "images": 
          {
            "image1": "../images/bastya/2026.01.21 - pótszilveszter/1.jpg",
            "image2": "../images/bastya/2026.01.21 - pótszilveszter/2.jpg",
            "image3": "../images/bastya/2026.01.21 - pótszilveszter/3.jpg",
            "image4": "../images/bastya/2026.01.21 - pótszilveszter/4.jpg",
            "image5": "../images/bastya/2026.01.21 - pótszilveszter/5.jpg",
            "image6": "../images/bastya/2026.01.21 - pótszilveszter/6.jpg",
            "image7": "../images/bastya/2026.01.21 - pótszilveszter/7.jpg",
            "image8": "../images/bastya/2026.01.21 - pótszilveszter/8.jpg",
            "image9": "../images/bastya/2026.01.21 - pótszilveszter/9.jpg",
            "image10": "../images/bastya/2026.01.21 - pótszilveszter/10.jpg",
            "image11": "../images/bastya/2026.01.21 - pótszilveszter/11.jpg",
            "image12": "../images/bastya/2026.01.21 - pótszilveszter/12.jpg",
            "image13": "../images/bastya/2026.01.21 - pótszilveszter/13.jpg",
            "image14": "../images/bastya/2026.01.21 - pótszilveszter/14.jpg",
            "image15": "../images/bastya/2026.01.21 - pótszilveszter/15.jpg",
            "image16": "../images/bastya/2026.01.21 - pótszilveszter/16.jpg",
            "image17": "../images/bastya/2026.01.21 - pótszilveszter/17.jpg",
            "image18": "../images/bastya/2026.01.21 - pótszilveszter/18.jpg",
            "image19": "../images/bastya/2026.01.21 - pótszilveszter/19.jpg",
            "image20": "../images/bastya/2026.01.21 - pótszilveszter/20.jpg",
            "image21": "../images/bastya/2026.01.21 - pótszilveszter/21.jpg",
            "image22": "../images/bastya/2026.01.21 - pótszilveszter/21.jpg",
            "image23": "../images/bastya/2026.01.21 - pótszilveszter/23.jpg",
            "image24": "../images/bastya/2026.01.21 - pótszilveszter/24.jpg",
            "image25": "../images/bastya/2026.01.21 - pótszilveszter/25.jpg",
            "image26": "../images/bastya/2026.01.21 - pótszilveszter/26.jpg",
            "image27": "../images/bastya/2026.01.21 - pótszilveszter/27.jpg",
            "image28": "../images/bastya/2026.01.21 - pótszilveszter/28.jpg",
          }
        
    },
    {
        "date": "2026-04-09",
        "title":"Farsang",
        "mainimage":"../images/bastya/2026.02.17-farsang/1.jpg",
        "images": 
          {
            "image1": "../images/bastya/2026.02.17-farsang/1.jpg",
            "image2": "../images/bastya/2026.02.17-farsang/2.jpg",
            "image3": "../images/bastya/2026.02.17-farsang/3.jpg",
            "image4": "../images/bastya/2026.02.17-farsang/4.jpg",
            "image5": "../images/bastya/2026.02.17-farsang/5.jpg",
            "image6": "../images/bastya/2026.02.17-farsang/6.jpg",
            "image7": "../images/bastya/2026.02.17-farsang/7.jpg",
            "image8": "../images/bastya/2026.02.17-farsang/8.jpg",
            "image9": "../images/bastya/2026.02.17-farsang/9.jpg",
            "image10": "../images/bastya/2026.02.17-farsang/10.jpg",
            "image11": "../images/bastya/2026.02.17-farsang/11.jpg",
            "image12": "../images/bastya/2026.02.17-farsang/12.jpg",
            "image13": "../images/bastya/2026.02.17-farsang/13.jpg",
            "image14": "../images/bastya/2026.02.17-farsang/14.jpg",
            "image15": "../images/bastya/2026.02.17-farsang/15.jpg",
          }
    }, {
        "date": "2026-04-04",
        "title":"Bolondozás Április 1.-én",
        "mainimage":"../images/bastya/2026.04.01-bolondozas/3.jpg",
        "images": 
          {
            "image3": "../images/bastya/2026.04.01-bolondozas/3.jpg",
            "image4": "../images/bastya/2026.04.01-bolondozas/4.jpg",
            "image5": "../images/bastya/2026.04.01-bolondozas/5.jpg",
            "image6": "../images/bastya/2026.04.01-bolondozas/6.jpg",
            "image7": "../images/bastya/2026.04.01-bolondozas/7.jpg",
            "image8": "../images/bastya/2026.04.01-bolondozas/8.jpg",
            "image9": "../images/bastya/2026.04.01-bolondozas/9.jpg",
            "image10": "../images/bastya/2026.04.01-bolondozas/10.jpg",
            "image11": "../images/bastya/2026.04.01-bolondozas/11.jpg",
            "image12": "../images/bastya/2026.04.01-bolondozas/12.jpg",
            "image13": "../images/bastya/2026.04.01-bolondozas/13.jpg",
            "image14": "../images/bastya/2026.04.01-bolondozas/14.jpg",
            "image15": "../images/bastya/2026.04.01-bolondozas/15.jpg",
            "image16": "../images/bastya/2026.04.01-bolondozas/16.jpg",
            "image17": "../images/bastya/2026.04.01-bolondozas/17.jpg",
            "image18": "../images/bastya/2026.04.01-bolondozas/18.jpg",
            "image19": "../images/bastya/2026.04.01-bolondozas/19.jpg",
            "image20": "../images/bastya/2026.04.01-bolondozas/20.jpg",
            "image21": "../images/bastya/2026.04.01-bolondozas/21.jpg",
            "image22": "../images/bastya/2026.04.01-bolondozas/22.jpg",
          }
    },
   
   
  ];